$exso_sheets_device $mol_page
	title @ \Станок {}
	body /
		<= Shifts $exso_table
			items <= shifts <= all_shifts /$exso_sheets_shift 
			Title null
			reverse true
			columns /
				/
					\place
					\block
				/
					\shift
					\date
				\supervisor
				/
					\value
					\wells_count
				/
					\fuel
					\fuel__value
				/
					\device
					\fuel_device
				/
					\compressor
					\fuel_compressor
				\redrill
				/
					\downtime
					\note
			columns_meta <= columns_meta *
